"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var ButtonGroup = antd_1.Button.Group;
var _cloneDeep = require('lodash/cloneDeep');
/**
 * Button group to re-order positions of rules.
 */
var RuleReorderButtons = /** @class */ (function (_super) {
    __extends(RuleReorderButtons, _super);
    function RuleReorderButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRuleOrderChange = function (moveDown) {
            var _a = _this.props, ruleIndex = _a.ruleIndex, rules = _a.rules, onRulesMove = _a.onRulesMove;
            var nextRuleIndex = moveDown ? ruleIndex + 1 : ruleIndex - 1;
            var rulesClone = _cloneDeep(rules);
            // shift rule one position up / down in rules array
            rulesClone.splice(nextRuleIndex, 0, rulesClone.splice(ruleIndex, 1)[0]);
            if (onRulesMove) {
                onRulesMove(rulesClone);
            }
        };
        return _this;
    }
    RuleReorderButtons.prototype.render = function () {
        var _this = this;
        var _a = this.props, locale = _a.locale, ruleIndex = _a.ruleIndex, rules = _a.rules;
        return (React.createElement(ButtonGroup, null,
            React.createElement(antd_1.Button, { icon: "up", disabled: ruleIndex === 0, title: locale.ruleMoveUpTip, onClick: function () {
                    _this.onRuleOrderChange(false);
                } }),
            React.createElement(antd_1.Button, { icon: "down", disabled: ruleIndex === rules.length - 1, title: locale.ruleMoveDownTip, onClick: function () {
                    _this.onRuleOrderChange(true);
                } })));
    };
    RuleReorderButtons.componentName = 'RuleReorderButtons';
    RuleReorderButtons.defaultProps = {
        locale: en_US_1.default.GsRuleReorderButtons
    };
    return RuleReorderButtons;
}(React.Component));
exports.RuleReorderButtons = RuleReorderButtons;
exports.default = LocaleWrapper_1.localize(RuleReorderButtons, RuleReorderButtons.componentName);
//# sourceMappingURL=RuleReorderButtons.js.map